/*
 * @Descripttion:
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-05 20:23:32
 * @LastEditors: ???
 * @LastEditTime: 2022-05-19 23:16:41
 */
import request from '@/utils/request';

// 社区
export function getCommunityList(data) {
  return request({
    url: '/address/community/list',
    method: 'post',
    data,
  });
}

// 街道
export function getStreetList(params) {
  return request({
    url: `/address/street/list`,
    method: 'get',
    params,
  });
}

// 回收员
export function getRecyclertList(data) {
  return request({
    url: `/recycleUser/list`,
    method: 'post',
    data,
  });
}

// 可回收统计
export function getRecycleSummary(data) {
  return request({
    url: `/user/statistical/completeOrderSummary`,
    method: 'post',
    data,
  });
}

// 预约统计
export function getOrderingSummary(data) {
  return request({
    url: `/user/statistical/bookingOrderSummary`,
    method: 'post',
    data,
  });
}

// 街道
export function getOrderDetail(params) {
  return request({
    url: `/user/statistical/bookingOrderDetail`,
    method: 'get',
    params,
  });
}

// 街道
export function getRecyclerList(params) {
  return request({
    url: `/address/street/list`,
    method: 'get',
    params,
  });
}
